export default {
    "20": [
        "BY",
        "KC",
        "KG",
        "L8",
        "SF",
        "Y9",
        "4U"
    ],
    "21": [
        "KK",
        "KT",
        "MP",
        "O4",
        "PE",
        "4U",
        "5K"
    ]
}